// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"34":"8fa0fe87","146":"564c228d","276":"46627cd8","510":"e11edd5e","922":"a89fb799","961":"6b59cafb"}[chunkId] + ".css";
};